"use client";
import { PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { SearchPill } from "./search-pill";
import { APP_TAB, AppTab } from "@/components/types";
import { AnalyticsEvent, trackEvent } from "@/lib/analytics";

const TAB_BREADCRUMBS: Record<AppTab, { module: string; page: string }> = {
  [APP_TAB.CARD_COLLECTION]: {
    module: "ClarityOS",
    page: "Card Collection Queue",
  },
  [APP_TAB.PATIENT_AR]: {
    module: "ClarityOS",
    page: "Patient AR",
  },
};

interface Props {
  activeTab: AppTab;
  onOpenSearch: VoidFunction;
  sidebarExpanded: boolean;
  onToggleSidebar: VoidFunction;
}

// function ClinicTokenStatus({
//   clinicAuthProof,
// }: {
//   clinicAuthProof?: ClinicAuthProof;
// }) {
//   if (!clinicAuthProof) {
//     return null;
//   }

//   if (clinicAuthProof.status === "verified") {
//     return (
//       <div
//         aria-label={`Clinic token verified for ${clinicAuthProof.practiceName}`}
//         className="hidden h-7 max-w-[320px] items-center gap-2 rounded-full border border-[#BFE5D8] bg-[#EFFAF5] px-3 text-xs font-medium text-[#166C4A] md:flex"
//         role="status"
//         title={`Backend verified clinic id ${clinicAuthProof.clinicId} through /api/ccof/${clinicAuthProof.clinicId}/practice`}
//       >
//         <ShieldCheck className="size-3.5 shrink-0" strokeWidth={2} />
//         <span className="shrink-0">Clinic token</span>
//         <span className="truncate text-[#1D7D59]">
//           {clinicAuthProof.practiceName}
//         </span>
//       </div>
//     );
//   }

//   if (clinicAuthProof.status === "error") {
//     return (
//       <div
//         aria-label={`Clinic token check failed for ${clinicAuthProof.clinicId}`}
//         className="hidden h-7 max-w-[320px] items-center gap-2 rounded-full border border-[#F2C7C3] bg-[#FFF3F1] px-3 text-xs font-medium text-[#A13D34] md:flex"
//         role="status"
//         title={`${clinicAuthProof.statusCode}: ${clinicAuthProof.message}`}
//       >
//         <ShieldAlert className="size-3.5 shrink-0" strokeWidth={2} />
//         <span className="shrink-0">Clinic token</span>
//         <span className="truncate">{clinicAuthProof.clinicId}</span>
//       </div>
//     );
//   }

//   return (
//     <div
//       aria-label={`Checking clinic token for ${clinicAuthProof.clinicId}`}
//       className="hidden h-7 max-w-[320px] items-center gap-2 rounded-full border border-(--border-subtle) bg-(--surface-subtle) px-3 text-xs font-medium text-(--content-secondary) md:flex"
//       role="status"
//       title={`Checking clinic id ${clinicAuthProof.clinicId} through /api/ccof/${clinicAuthProof.clinicId}/practice`}
//     >
//       <LoaderCircle
//         className="text-content-tertiary size-3.5 shrink-0 animate-spin"
//         strokeWidth={2}
//       />
//       <span className="shrink-0">Clinic token</span>
//       <span className="truncate">{clinicAuthProof.clinicId}</span>
//     </div>
//   );
// }

export default function TopBar({
  activeTab,
  onOpenSearch,
  sidebarExpanded,
  onToggleSidebar,
}: Props) {
  const breadcrumb = TAB_BREADCRUMBS[activeTab];

  return (
    <header className="z-10 flex h-16 shrink-0 items-center justify-between px-6">
      {/* Left: Sidebar toggle + Breadcrumb */}
      <div className="flex items-center gap-2">
        <button
          onClick={onToggleSidebar}
          title={sidebarExpanded ? "Collapse sidebar" : "Expand sidebar"}
          className="rounded-control hover:bg-surface-subtle flex size-7 shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent transition-colors duration-150 ease-out"
        >
          {sidebarExpanded ? (
            <PanelLeftClose
              className="size-[18px] text-(--content-secondary)"
              strokeWidth={1.7}
            />
          ) : (
            <PanelLeftOpen
              className="size-[18px] text-(--content-secondary)"
              strokeWidth={1.7}
            />
          )}
        </button>
        <span className="text-content-tertiary text-sm">
          {breadcrumb.module}
        </span>
        <span className="text-content-tertiary text-[10px] font-medium">/</span>
        <span className="text-content-primary text-sm">{breadcrumb.page}</span>
      </div>
      {/* Right: Search pill + notification bell */}
      <div className="flex items-center gap-3">
        {/* <ClinicTokenStatus clinicAuthProof={clinicAuthProof} /> */}
        <SearchPill
          onClick={() => {
            trackEvent(AnalyticsEvent.PatientSearch, {});
            onOpenSearch();
          }}
        />

        {/* Notification bell removed */}
      </div>
    </header>
  );
}
